var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import rolePerimeter from 'services/kindergarten/perimeters/Role';
import CONSTANTS from 'services/CONSTANTS';
var AuthMixin = (function (_super) {
    __extends(AuthMixin, _super);
    function AuthMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userCookie = process.env.ZEPWAY_AUTH_USER_COOKIE;
        _this.username = null;
        _this.password = null;
        _this.loginHasError = false;
        return _this;
    }
    AuthMixin.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    this.$auth.logout().then(function () {
                        if (_this.$route.path !== '/') {
                            _this.$router.push('/login');
                        }
                    });
                }
                catch (err) {
                    this.$toast.error(this.$t('messages.error.server_error') + ': ' + err.message);
                }
                return [2];
            });
        });
    };
    AuthMixin.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.$auth.login({
                                data: {
                                    login: this.username,
                                    password: this.password
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [4, this.$auth.fetchUser()];
                    case 2:
                        _a.sent();
                        this.goToAccount();
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        msg = this.$t('messages.error.server_error');
                        if (err_1.response && err_1.response.status && 401 === err_1.response.status) {
                            msg = this.$t('messages.error.username_or_password');
                        }
                        this.$toast.error(msg);
                        this.loginHasError = true;
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    AuthMixin.prototype.goToAccount = function () {
        this.$router.push(CONSTANTS.REDIRECT_MAP[this.$auth.$state.user.role] || CONSTANTS.REDIRECT_MAP.default);
    };
    AuthMixin = __decorate([
        Component({
            perimeters: [rolePerimeter]
        })
    ], AuthMixin);
    return AuthMixin;
}(Vue));
export default AuthMixin;



//////////////////
// WEBPACK FOOTER
// ./mixins/auth.ts
// module id = ./mixins/auth.ts
// module chunks = 10 11 15 18